module.exports = __webpack_public_path__ + "static/img/2.5cc43f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/2.jpg
// module id = syI5
// module chunks = 1